import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { toast } from "react-toastify"; // Import toast from react-toastify
import "react-toastify/dist/ReactToastify.css"; // Import toast CSS

const apiBase = process.env.REACT_APP_API;

const PayBank = ({ setCartItemCount }) => {
  const [file, setFile] = useState(null);
  const [bank, setBank] = useState(null);
  const [uploadStatus, setUploadStatus] = useState("");
  const [cartItem, setCartItem] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isUploding, setIsUploading] = useState(false);
  const navigate = useNavigate();
  const storedItem = JSON.parse(localStorage.getItem("cartItems"));

  const token = localStorage.getItem("token");

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleBankChnage = (e) => {
    setBank(e.target.value);
  };
  useEffect(() => {
    if (!token) {
      // alert("login first");
      toast.error("You have to login first!");
      navigate("/login");
    }
    const fetchCartItem = async () => {
      setIsLoading(true);
      const storedItem = JSON.parse(localStorage.getItem("cartItems"));
      if (!storedItem) {
        navigate("/cart");
        toast.error("Sorry your cart is empty !");
      }
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(
          `${apiBase}/payments/cart?quota_id=${storedItem.quota_id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const itemDetails = await response.json();
        setCartItem({ ...storedItem, ...itemDetails });
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching cart item details:", error);
      }
    };

    fetchCartItem();
  }, []);

  console.log(cartItem);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsUploading(true);
    if (!file) {
      setUploadStatus("Please select a file to upload.");
      setIsUploading(false);
      return;
    }
    if (!bank) {
      setUploadStatus("Please select the bank name");
      setIsUploading(false);
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("amount", cartItem.price.toFixed(2));
    formData.append("course_id", storedItem.course_id);
    formData.append("quota_id", cartItem.quota_id);
    formData.append("bank", bank);

    try {
      const response = await axios.post(`${apiBase}/payments/bank`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `bearer ${token}`,
        },
      });

      if (response.status === 200) {
        localStorage.removeItem("cartItems");
        setCartItemCount(0);
        toast.success("Wait for payment approval.");

        navigate("/profile");
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      setUploadStatus(
        error.response ? error.response.data.message : "Error uploading file"
      );
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className="flex items-center justify-center mb-3">
      <div className="mt  px-4 w-full lg:w-[1024px] flex flex-col  justify-center">
        <Link to={"/cart"}>
          <h1 className="flex flex-row items-center mb-16">
            <MdKeyboardArrowLeft className="text-4xl" />
            <div className="text-2xl opacity-50 font-medium uppercase hover:underline">
              Back to Cart
            </div>
          </h1>
        </Link>
        <div className="flex flex-col items-center justify-center lg:ffw-[500px]  p-6 bg-gray-50 rounded-lg shadow-lg max-w-md mx-auto">
          <div>
            <p>
              🛑 පාඨමාලාවට අදාල මුදල අපගේ බැංකු ගිණුමට බැර කල පසු, රිසිට්පතක්
              ලබාගැනීම අනිවාර්ය වේ.
            </p>
            <div className="text-center my-4">
              <p className="text-lg font-medium text-gray-700">
                <Link
                  to={"/support/bankdetails"}
                  className="text-myBlue font-semibold underline hover:text-myPurple transition-colors duration-300"
                >
                  Click here
                </Link>{" "}
                to see bank details
              </p>
            </div>
            <p>
              🛑 එම රිසිට්පතෙහි ඉදිරිපස පහත තොරතුරු <strong>පෑනකින්</strong>{" "}
              ලියා upload කිරීමද අනිවාර්යයි.
              <br />
              <ul className="mt-5 ml-5">
                <li>
                  🟩 ඔබ පාඨමාලාවට register වීමේදී අප ලබාදෙන ඇතුලත් වීමේ අංකය
                  (registration number ){" "}
                </li>
                <li>
                  🟩 ඔබ register වීම සඳහා භාවිතා කල දුරකථන අංකය. (මෙය නැවත වෙනස්
                  කල නොහැක){" "}
                </li>
                <li>🟩 ඔබ පාඨමාලාව මිලදීගත් මාසය</li>
              </ul>
            </p>
            <br />
            <p>
              🛑 Online payments කරන අය. <br />
              Online payment එක කරන වෙලාවෙදි payment එක ගැන විස්තරයක් දාන්න පුළුවන් field එකක් තියනව. ඔයාල use කරන app එක අනුව ඒ filed එක හඳුන්වන්න විවිධ නම් use වෙනව.
              eg:
                  <ul className="mt-5 ml-5">
                    <li>🔸Remarks </li>
                    <li>🔸Reference number</li>
                    <li>🔸Description</li>
                    <li>🔸Beneficiary's account narration</li>
                  </ul>
                  <br />
                  <p>
                    පහලින් දාල තියන විස්තර ටික ඒ field එකේ type කරන්න.
                  </p>
                    
                  <ol className="mt-5 ml-5">
                    <li>🟩 ඔයාගේ admission number එක දාන්න ඒක අනිවාර්යයි‼</li>
                    <li>🟩 Course unit එක</li>
                    <li>🟩 සම්බන්ධ වෙන මාසය සහ group එක</li>
                  </ol>

                  <p>
                    Eg:- (June old/June new)
                    ඒ ඔක්කොම දාන්න reference or remarks වල ඉඩ මදි වෙනවා නම් (JO/JN) කියලා දාන්න. 
                  </p>
            </p>
          </div>
          <br />
          <form onSubmit={handleSubmit} className="w-full ">
            <div>
              <select onChange={handleBankChnage} name="bank_name" id="">
                <option value="">select bank</option>
                <option value="BOC">BOC</option>
                <option value="PEOPLES">PEOPLES</option>
                <option value="HNB">HNB</option>
                <option value="SAMPATH">SAMPATH</option>
                <option value="COMMERCIAL">COMMERCIAL</option>
              </select>
            </div>

            <div className="mb-6">
              <label
                htmlFor="file"
                className="block text-lg font-medium text-gray-700"
              >
                Upload your bank slip
              </label>
              <input
                type="file"
                id="file"
                accept="image/png, image/jpeg, image/jpg"
                onChange={handleFileChange}
                className="mt-2 block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
              />
            </div>
            <p className=" text-center text-sm opacity-50 pb-4">
              Please note: We only support PNG, JPEG, or JPG file under 2MB.
            </p>
            {!isUploding ? (
              <button
                disabled={isLoading}
                type="submit"
                className="w-full py-3 bg-blue-600 text-white font-semibold rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
              >
                Upload
              </button>
            ) : (
              <div className="w-full py-3 flex items-center justify-center bg-blue-600 text-white font-semibold rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                <svg
                  className="animate-spin h-5 w-5 mr-2 text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                  ></path>
                </svg>
                Uploading...
              </div>
            )}
          </form>
          {uploadStatus && (
            <p className="mt-4 text-red-500 text-sm">{uploadStatus}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PayBank;
